<div class="card">
    <div class="card-body">
        <h5 class="card-title">{{title}}</h5>
        <p class="card-text">{{message}}</p>
        <div class="text-end">
            <button type="button" class="btn btn-default" (click)="close(true)">{{negativeButtonText}}</button>
            <button type="button" class="btn btn-primary" (click)="confirm(false)">{{positiveButtonText}}</button>
        </div>
    </div>
  </div>